module.exports = __webpack_public_path__ + "static/13-mission2-search-360f8892dd0b37674c36bff5361e4bb3.png";